import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-90" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-3xl px-4" data-id="element-91" data-mp="9ucrn7u79n36">
        <div className="rounded-2xl border border-[var(--lilac)]/40 bg-[#16102e] p-8 text-center sm:p-12" data-id="element-92" data-mp="9tl66pubh5qm">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--lilac)]/15" data-id="element-93" data-mp="ev0sel88dial">
            <ShieldCheckIcon className="h-9 w-9 text-[var(--lilac)]" aria-hidden="true" data-id="element-94" data-mp="jsag9wfz1lwb" />
          </span>
          <h2 className="mt-6 font-display text-3xl font-extrabold text-[var(--cream)] sm:text-4xl" data-id="element-95" data-mp="skcctjmx6i1b">
            Garantía 7 días — Sin preguntas
          </h2>
          <p className="mt-5 text-white/75" data-id="element-96" data-mp="xm1lwtql0lmr">
            Descargás. Cocinás la primera semana.
          </p>
          <p className="mt-2 text-white/75" data-id="element-97" data-mp="12h78zvvq06cf">Si no es lo que esperabas:</p>
          <p className="mt-4 text-lg font-semibold text-[var(--lilac-light)]" data-id="element-98" data-mp="17id2vx149znj">
            Devolución del 100% · Sin formularios · Sin drama.
          </p>
          <p className="mt-4 text-sm text-white/50" data-id="element-99" data-mp="20sati76f71n0">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}